var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 12.8672C12.2711 12.8672 12.5859 12.5524 12.5859 12.1641C12.5859 11.7757 12.2711 11.4609 11.8828 11.4609C11.4945 11.4609 11.1797 11.7757 11.1797 12.1641C11.1797 12.5524 11.4945 12.8672 11.8828 12.8672Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 15.8906C15.4352 15.8906 15.75 15.5758 15.75 15.1875V9.42188C15.75 7.87106 14.4883 6.60938 12.9375 6.60938H12.0924V4.12966C12.0924 1.85256 10.1999 0 7.8737 0C5.54748 0 3.65495 1.85256 3.65495 4.12966V6.60938H2.8125C1.26169 6.60938 0 7.87106 0 9.42188V15.1875C0 16.7383 1.26169 18 2.8125 18H12.9375C14.4883 18 15.75 16.7383 15.75 15.1875C15.75 14.7992 15.4352 14.4844 15.0469 14.4844C14.6585 14.4844 14.3438 14.7992 14.3438 15.1875C14.3438 15.9629 13.7129 16.5938 12.9375 16.5938H2.8125C2.03709 16.5938 1.40625 15.9629 1.40625 15.1875V9.42188C1.40625 8.64647 2.03709 8.01562 2.8125 8.01562H12.9375C13.7129 8.01562 14.3438 8.64647 14.3438 9.42188V15.1875C14.3438 15.5758 14.6585 15.8906 15.0469 15.8906ZM10.6862 6.60938H5.0612V4.12966C5.0612 2.62796 6.32289 1.40625 7.8737 1.40625C9.42451 1.40625 10.6862 2.62796 10.6862 4.12966V6.60938Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57422 12.8672C6.96254 12.8672 7.27734 12.5524 7.27734 12.1641C7.27734 11.7757 6.96254 11.4609 6.57422 11.4609C6.18589 11.4609 5.87109 11.7757 5.87109 12.1641C5.87109 12.5524 6.18589 12.8672 6.57422 12.8672Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 12.8672C4.32583 12.8672 4.64062 12.5524 4.64062 12.1641C4.64062 11.7757 4.32583 11.4609 3.9375 11.4609C3.54917 11.4609 3.23438 11.7757 3.23438 12.1641C3.23438 12.5524 3.54917 12.8672 3.9375 12.8672Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 12.8672C9.59926 12.8672 9.91406 12.5524 9.91406 12.1641C9.91406 11.7757 9.59926 11.4609 9.21094 11.4609C8.82261 11.4609 8.50781 11.7757 8.50781 12.1641C8.50781 12.5524 8.82261 12.8672 9.21094 12.8672Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.1ecb94f739f4c43d3e2ad122c9fe8c39.svg";
export { ForwardRef as ReactComponent };